// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import Container from "./Container-APP_CLIENT.styled";

export default Container;
